/* eslint no-console:0 */

// load stylesheets
require.context("./stylesheets/s2_api", false);

// load react components we want to render from rails views
import ReactOnRails from 'react-on-rails';
import Confirmation from './react/s2_api/Confirmation';
import DexyReferral from './react/s2_api/DexyReferral';
import NhsReferral from './react/s2_api/NhsReferral';
import SchoolReferral from './react/s2_api/SchoolReferral';
import TFTReferral from './react/s2_api/TFTReferral';
import ExchangeParentReferral from './react/s2_api/ExchangeParentReferral';
import ExchangeParentReferralFull from './react/s2_api/ExchangeParentReferralFull';
import NeuroPathwaysReferral from './react/s2_api/NeuroPathwaysReferral';

ReactOnRails.register({ Confirmation, DexyReferral, NhsReferral, SchoolReferral, TFTReferral, ExchangeParentReferral, ExchangeParentReferralFull, NeuroPathwaysReferral });

// enable delete links and alerts
import Rails from '@rails/ujs';
Rails.start();
